import React from "react";
import { useSeo } from "@/hooks/useSeo";
import { SEO } from "@/data/seo";
import { SERVICE_AREAS } from "@/data/serviceAreas";
import { Overline, PrimaryButton, SecondaryButton, Crumbs } from "@/components/Primitives";
import CTABlock from "@/components/CTABlock";

const ServiceAreas = () => {
  useSeo(SEO.serviceAreas);
  return (
    <main data-testid="service-areas-page" className="bg-black">
      <section className="bg-black text-white border-b border-white/10">
        <div className="max-w-[1440px] mx-auto px-5 lg:px-10 py-12 lg:py-20">
          <Crumbs items={[{ to: "/", label: "Home" }, { label: "Service Areas" }]} />
          <h1 className="mt-6 text-5xl sm:text-6xl lg:text-[80px] font-black tracking-tighter leading-[0.92]">
            Based in <span className="k-yellow">{SERVICE_AREAS.province}</span>. Working across Canada.
          </h1>
          <p className="mt-5 max-w-2xl text-white/70 text-lg">{SERVICE_AREAS.note}</p>
        </div>
      </section>
      <section className="bg-black border-b border-white/10">
        <div className="max-w-[1440px] mx-auto px-5 lg:px-10 py-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-px bg-white/10 border border-white/15">
          {SERVICE_AREAS.cities.map((c) => (
            <div
              key={c}
              data-testid={`area-${c.toLowerCase().replace(/\s+/g, "-")}`}
              className="bg-black p-5 lg:p-7"
            >
              <Overline className="mb-2">City</Overline>
              <div className="text-2xl lg:text-3xl font-black tracking-tighter">{c}</div>
            </div>
          ))}
          <div className="bg-[#FFC600] p-5 lg:p-7 col-span-2 md:col-span-3 lg:col-span-2">
            <Overline className="mb-2">Remote</Overline>
            <div className="text-2xl lg:text-3xl font-black tracking-tighter">{SERVICE_AREAS.remote}</div>
          </div>
        </div>
      </section>
      <CTABlock variant="default" />
    </main>
  );
};

export default ServiceAreas;
